/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  GetAllIncidentStatusesParams,
  IReadOnlyListOfIncidentStatusDto,
  IncidentStatusDto
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns all incidentstatuses enumeration values, with an optional filter.
 */
export const getAllIncidentStatuses = (
    params?: GetAllIncidentStatusesParams,
 options?: SecondParameter<typeof customInstance<IReadOnlyListOfIncidentStatusDto>>,) => {
      return customInstance<IReadOnlyListOfIncidentStatusDto>(
      {url: `/incident-management/incident-statuses`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Returns the IncidentStatus identified by the route id.
 */
export const getIncidentStatusById = (
    id: number,
 options?: SecondParameter<typeof customInstance<IncidentStatusDto>>,) => {
      return customInstance<IncidentStatusDto>(
      {url: `/incident-management/incident-statuses/${id}`, method: 'GET'
    },
      options);
    }
  export type GetAllIncidentStatusesResult = NonNullable<Awaited<ReturnType<typeof getAllIncidentStatuses>>>
export type GetIncidentStatusByIdResult = NonNullable<Awaited<ReturnType<typeof getIncidentStatusById>>>
